import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_CIVILBUDGETMATERIAL,
  DELETE_CIVILBUDGETMATERIAL,
  UPDATE_CIVILBUDGETMATERIAL,
  ADD_NEW_CIVILBUDGETMATERIAL,
} from "./actionType";

import {
  getCivilBudgetMaterialSuccess,
  getCivilBudgetMaterialFail,
  deleteCivilBudgetMaterialSuccess,
  deleteCivilBudgetMaterialFail,
  updateCivilBudgetMaterialSuccess,
  updateCivilBudgetMaterialFail,
  addCivilBudgetMaterialSuccess,
  addCivilBudgetMaterialFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  getCivilBudgetMaterialApi,
  updateCivilBudgetMaterialApi,
  deleteCivilBudgetMaterialApi,
  addNewCivilBudgetMaterialApi,
  approveCivilBudgetMaterialApi
} from "../../helpers/backend_helper";

function* getCivilBudgetMaterial({ payload: civilBudgetMaterial }) {
  try {
    const response = yield call(getCivilBudgetMaterialApi, civilBudgetMaterial);
    yield put(getCivilBudgetMaterialSuccess(GET_CIVILBUDGETMATERIAL, response.data));
  } catch (error) {
    yield put(getCivilBudgetMaterialFail(GET_CIVILBUDGETMATERIAL, error));
  }
}

function* onUpdateCivilBudgetMaterial({ payload: civilBudgetMaterial }) {
  try {
    if (civilBudgetMaterial.setApprove) {
      const response = yield call(approveCivilBudgetMaterialApi, civilBudgetMaterial);
      yield put(updateCivilBudgetMaterialSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateCivilBudgetMaterialApi, civilBudgetMaterial);
      yield put(updateCivilBudgetMaterialSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateCivilBudgetMaterialFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteCivilBudgetMaterial({ payload: civilBudgetMaterial }) {
  try {
    const response = yield call(deleteCivilBudgetMaterialApi, civilBudgetMaterial);
    yield put(deleteCivilBudgetMaterialSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteCivilBudgetMaterialFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewCivilBudgetMaterial({ payload: civilBudgetMaterial }) {
  try {
    const response = yield call(addNewCivilBudgetMaterialApi, civilBudgetMaterial);
    yield put(addCivilBudgetMaterialSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addCivilBudgetMaterialFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetCivilBudgetMaterial() {
  yield takeEvery(GET_CIVILBUDGETMATERIAL, getCivilBudgetMaterial);
}

export function* watchUpdateCivilBudgetMaterial() {
  yield takeEvery(UPDATE_CIVILBUDGETMATERIAL, onUpdateCivilBudgetMaterial);
}

export function* watchDeleteCivilBudgetMaterial() {
  yield takeEvery(DELETE_CIVILBUDGETMATERIAL, onDeleteCivilBudgetMaterial);
}

export function* watchAddNewCivilBudgetMaterial() {
  yield takeEvery(ADD_NEW_CIVILBUDGETMATERIAL, onAddNewCivilBudgetMaterial);
}

function* civilBudgetMaterialSaga() {
  yield all([
    fork(watchGetCivilBudgetMaterial),
    fork(watchDeleteCivilBudgetMaterial),
    fork(watchUpdateCivilBudgetMaterial),
    fork(watchAddNewCivilBudgetMaterial)
  ]);
}

export default civilBudgetMaterialSaga;
